import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DisiApi from "datas/disi/DisiApi";
import ConstantsResult from "domains/entity/main/ConstantResult";
import PettyCashUseCase from "domains/interactor/main/disi/PettyCash";

type iState = {
    data: ConstantsResult;
    loading: boolean;
    error: any;
}

const initialState: iState = {
    data: [],
    loading: false,
    error: ""
}

export const pettyCashStatusAction = createAsyncThunk('petty-cash-status-action', async (_, { rejectWithValue }) => {
    try {

        const useCase = new PettyCashUseCase(new DisiApi())

        return await useCase.getPettyCashStatus()
    } catch (error) {
        const { response } = error;
        if (!response) {
            throw error
        }
        return rejectWithValue(response.data)
    }
})

const pettyCashStatusSlice = createSlice({
    name: "petty-cash-status-slice",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(pettyCashStatusAction.pending, state => {
            state.loading = true;
            state.error = ""
        })
        builder.addCase(pettyCashStatusAction.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload
            state.error = ""
        })
        builder.addCase(pettyCashStatusAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})


const pettyCashStatusReducer = pettyCashStatusSlice.reducer

export default pettyCashStatusReducer